export default function TrustSection() {
  return (
    <section id="o-nas" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="animate-fade-in-up">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-8">
              USFansSpreadsheet –
              <br />
              Twoje centrum
              <br />
              ekspertów
            </h2>

            <div className="grid grid-cols-3 gap-6 md:gap-8">
              <div className="border-r border-background-200 pr-4 md:pr-6">
                <p className="text-3xl md:text-5xl font-bold text-primary-500 font-heading">
                  150<span className="text-primary-400">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed">
                  Artykułów SEO
                </p>
              </div>
              <div className="border-r border-background-200 pr-4 md:pr-6">
                <p className="text-3xl md:text-5xl font-bold text-primary-500 font-heading">
                  14
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed">
                  Kategorii produktów
                </p>
              </div>
              <div className="pr-0">
                <p className="text-3xl md:text-5xl font-bold text-primary-500 font-heading">
                  10k<span className="text-primary-400">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed">
                  Zadowolonych użytkowników
                </p>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4 text-xs md:text-sm text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-star-line text-primary-500"></i>
                Ekspert ds. analizy danych
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-check-line text-primary-500"></i>
                Aktualizacja: Czerwiec 2026
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-primary-500"></i>
                Badania i analizy branżowe
              </span>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-gradient-to-br from-secondary-200 via-secondary-100 to-primary-100">
              <div className="absolute top-10 left-10 w-32 h-32 rounded-2xl bg-primary-200/40"></div>
              <div className="absolute top-20 right-16 w-24 h-24 rounded-full bg-accent-200/40"></div>
              <div className="absolute bottom-16 left-20 w-40 h-28 rounded-2xl bg-secondary-300/50"></div>
              <div className="absolute bottom-10 right-10 w-28 h-28 rounded-full bg-primary-300/30"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-accent-100/30"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}